// extracted by mini-css-extract-plugin
export default {"loading":"Text_loading__F+6pX","shimmer":"Text_shimmer__qrZJK"};